export const environment = {
  production: true,
  apiUrl: "https://api.topturo.com/v1/",
  inventoryUri: "http://s3-us-west-1.amazonaws.com/www.topturo.com/assets/inventory.json",
  s3Images: "https://s3-us-west-1.amazonaws.com/dopeminer-images",
  envName: "production"
};
